// extracted by mini-css-extract-plugin
module.exports = {"selectFile":"UploadFile_selectFile__A-U4k","suffix":"UploadFile_suffix__ZRU8p","disabledSelectedFile":"UploadFile_disabledSelectedFile__3Q4pe"};